import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'user',
    initialState: {
        username: null,
        userId: null, // Store user's ID
    },
    reducers: {
        setUser: (state, action) => {
            state.username = action.payload.username;
            state.firstname = action.payload.firstname;
            state.lastname = action.payload.lastname;
            state.nickname = action.payload.nickname;
            state.email = action.payload.email;
            state.userId = action.payload.userId; // Store userId upon login
        },
        clearUser: (state) => {
            state.username = null;
            state.firstname = null;
            state.lastname = null;
            state.nickname = null;
            state.email = null;
            state.userId = null;
        },
    },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;